function init() {
	const visualiser = document.querySelector('.grid-visualiser');
	if (!visualiser) {
		return;
	}

	window.addEventListener('keydown', (e) => {
		if ('g' === e.key || 'G' === e.key) {
			visualiser.classList.toggle('grid-visualiser--visible')
		}
	});
}

export default {
	init,
}



// WEBPACK FOOTER //
// ./scripts/modules/grid-visualiser.js